// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DynProperty, PairColor } from '@shared/commons/DynProperty';
import { Color } from '@shared/commons/Graphics';
import { Resources } from '@shared/localizations/Resources';
import { RowPropertyClass } from './RowPropertyClass';
export class VerticalPanelDataProviderItem extends RowPropertyClass {
    constructor() {
        super(...arguments);
        this.HeaderBackColor = Color.Empty;
        this.HeaderForeColor = Color.Empty;
        this.ValueBackColor = Color.Empty;
        this.ValueForeColor = Color.Empty;
        /// <summary>
        /// завел чтоб создавать если надо типизирование экшн-контролы. (напр. кнопки, линки)
        /// </summary>
        this.DynPropertyControltype = DynProperty.STRING;
        this.GroupIndex = null;
    }
    Reset(Visible) {
        this.visible = Visible;
        this.HeaderBackColor = this.HeaderForeColor = this.ValueBackColor = this.ValueForeColor = Color.Empty;
    }
    Apply(sourceItem) {
        this.visible = sourceItem.visible;
        this.HeaderBackColor = sourceItem.HeaderBackColor;
        this.HeaderForeColor = sourceItem.HeaderForeColor;
        this.ValueBackColor = sourceItem.ValueBackColor;
        this.ValueForeColor = sourceItem.ValueForeColor;
    }
    Properties() {
        const result = [];
        let dp = new DynProperty('HeaderColors', new PairColor(this.HeaderForeColor, this.HeaderBackColor), DynProperty.PAIR_COLOR, DynProperty.COLORS_GROUP);
        dp.propertyComment = Resources.getResource('property.LabelColors');
        result.push(dp);
        dp = new DynProperty('ValueColors', new PairColor(this.ValueForeColor, this.ValueBackColor), DynProperty.PAIR_COLOR, DynProperty.COLORS_GROUP);
        dp.propertyComment = Resources.getResource('property.ValueColors');
        result.push(dp);
        return result;
    }
    callBack(v) {
        let p = DynProperty.getPropertyByName(v, 'HeaderColors');
        if (p != null /* && p.Value is PairColor */) {
            const pairColor = p.value;
            this.HeaderForeColor = pairColor.Color1;
            this.HeaderBackColor = pairColor.Color2;
        }
        p = DynProperty.getPropertyByName(v, 'ValueColors');
        if (p === null || p === void 0 ? void 0 : p.value /* is PairColor */) {
            const pairColor = p.value;
            this.ValueForeColor = pairColor.Color1;
            this.ValueBackColor = pairColor.Color2;
        }
    }
}
